import { render } from "./OfferCards.vue?vue&type=template&id=64bdf3c8&scoped=true"
import script from "./OfferCards.vue?vue&type=script&lang=js"
export * from "./OfferCards.vue?vue&type=script&lang=js"

import "./OfferCards.vue?vue&type=style&index=0&id=64bdf3c8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64bdf3c8"]])

export default __exports__